/*
 Created by qing on 2022/6/9 下午9:41
 Des: 关联查询
 */

import BaseItem from "../BaseItem"
import {
  FORM_ITEM__LINK_QUERY, DATA_TYPE__JSON,
  FORM_ITEM__TABLE, FORM_ITEM__THIRD_DATA_TABLE
} from "../types"

class LinkQuery extends BaseItem {

  constructor() {
    super()
    this.value = {}

    this.dataAppId = ''
    this.dataFormId = ''
    this.detailViewId = ''
    this.sortList = [
      {
        fieldId: "updateTime",
        sortType: -1 // -1 降序 1 正序、、 -1：Z-A  1:A-Z 、、 -1最新在前， 1最旧在前
      }
    ]
    this.filter = {
      relation: 'and',
      jumpEmpty: 0,
      conditionList: []
    }
    this.showFieldIdList = []
    this.refreshFieldIdList = []
    this.linkShowStyle = "TIME-3" //TIME-3 时间轴显示3条 LIST 列表显示3条 TABLE 表格显示
    this.pcShowTable = 'NO'
    this.listShowNumber = 1
    this.timeFieldId = "" // 时间字段
    this.linkTitle = ""  // 关联标题
    this.linkDetail = "" //  关联详情
    this.linkMemberFieldId = "" // 关联的成员字段
    this.showRefresh = "YES" //显示手动刷新字段
    this.styleInfo = {
      mainColor: 'rgba(233, 237, 242, 1)',
      headerColor: 'rgba(122, 128, 136, 1)',
      contentColor: 'rgba(65, 68, 72, 1)',
      alignment: 'left'
    }
  }

  get title() {
    return this.fieldTitle || LinkQuery._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

LinkQuery._title = '关联查询'
LinkQuery.type = FORM_ITEM__LINK_QUERY
LinkQuery.use = true
LinkQuery.prototype.icon = 'el-icon-video-play'

LinkQuery.prototype.type = LinkQuery.type
LinkQuery.prototype.dataType = DATA_TYPE__JSON
LinkQuery.prototype.defaultValueList = []

LinkQuery.prototype.filterOpts = [
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
LinkQuery.prototype.getValue = function () {
  return this.value
}
LinkQuery.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || []
}
LinkQuery.prototype.setConf = function (opts) {
  if (opts) {
    this.setBase(opts)

    this.dataAppId = opts.dataAppId
    this.dataFormId = opts.dataFormId
    this.detailViewId = opts.detailViewId
    this.sortList = opts.sortList
    this.filter = opts.filter
    this.showFieldIdList = opts.showFieldIdList
    this.refreshFieldIdList = opts.refreshFieldIdList
    this.linkShowStyle = opts.linkShowStyle
    this.pcShowTable = opts.pcShowTable
    this.listShowNumber = opts.listShowNumber
    this.timeFieldId = opts.timeFieldId
    this.linkTitle = opts.linkTitle
    this.linkDetail = opts.linkDetail
    this.linkMemberFieldId = opts.linkMemberFieldId
    this.showRefresh = opts.showRefresh
    this.styleInfo = opts.styleInfo
  }
}
LinkQuery.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    dataAppId: this.dataAppId,
    dataFormId: this.dataFormId,
    detailViewId: this.detailViewId,
    sortList: this.sortList,
    filter: this.filter,
    showFieldIdList: this.showFieldIdList,
    refreshFieldIdList: this.refreshFieldIdList,
    linkShowStyle: this.linkShowStyle,
    pcShowTable: this.pcShowTable,
    listShowNumber: this.listShowNumber,
    timeFieldId: this.timeFieldId,
    linkTitle: this.linkTitle,
    linkDetail: this.linkDetail,
    linkMemberFieldId: this.linkMemberFieldId,
    showRefresh: this.showRefresh,
    styleInfo: this.styleInfo
  }
}
LinkQuery.prototype.valueToString = function (value) {
  return ''
}
export default LinkQuery
